module.exports = __webpack_public_path__ + "static/media/sudoGPRfour.7bda14e7.jpg";